var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { StorageService } from '../storage.service';
import { AppConstant } from '../app.constant';
import { CognitoUtil } from '../common/cognito.service';
import { Router } from '@angular/router';
import { AppUtil } from '../app.service';
var HttpService = /** @class */ (function () {
    function HttpService(_http, appservice, cognitoUtil, router, spinner) {
        this._http = _http;
        this.appservice = appservice;
        this.cognitoUtil = cognitoUtil;
        this.router = router;
        this.spinner = spinner;
        this.dummy = true;
    }
    HttpService.prototype.logout = function () {
        // console.log('UserLoginService: Logging out');
        // this.cognitoUtil.getCurrentUser().signOut();
        this.router.navigate(['/login']);
    };
    HttpService.prototype.printIdToken = function () {
        this.cognitoUtil.getIdToken({
            callback: function () {
            },
            callbackWithParam: function (param) {
                if (!param) {
                    //     console.log('cant get id token');
                }
                else {
                    //   console.log('ID token of user', param);
                }
            }
        });
    };
    HttpService.prototype.getHeader = function (json, noAuth) {
        var _this = this;
        this.printIdToken();
        var that = this;
        var header = new HttpHeaders();
        if (json) {
            header = header.append('Content-Type', 'application/json');
            // header = header.append('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE');
        }
        return new Observable(function (observer) {
            // TODO have to remove this once authorizer enabled for API's
            /* observer.next(header);
             return;*/
            if (noAuth) {
                observer.next(header);
            }
            else if (that.token) {
                header = header.append('Authorization', that.token);
                observer.next(header);
            }
            else {
                _this.cognitoUtil.getAccessToken({
                    callback: function () {
                    },
                    callbackWithParam: function (param) {
                        if (!param) {
                            //    console.log('user not logged in');
                            _this.logout();
                            observer.error();
                        }
                        else {
                            //  console.log('got token ', param);
                            that.token = param;
                            header = header.append('Authorization', param);
                            observer.next(header);
                        }
                    }
                });
            }
        });
    };
    HttpService.prototype.handler = function (httpResult, observer, cache) {
        var _this = this;
        httpResult
            .subscribe(function (response) {
            _this.spinner.spinnerDone();
            // console.log('response  ', response);
            // if (this.dummy) {
            //   this.tryRefreshToken(observer, cache);
            //   this.dummy = false;
            // console.log('cache', cache);
            // } else {
            observer.next(response);
            // }
        }, function (err) {
            // console.log('http error++', err);
            if (err.status === 401) {
                // console.log(err);
                // console.log('user token invalid or expired');
                // TODO due to incompatability with aws response can't diff invalid token & expired token
                _this.tryRefreshToken(observer, cache);
                // this.logout();
            }
            else {
                _this.spinner.spinnerDone();
                observer.error(err);
            }
        });
    };
    HttpService.prototype.getAuthHeader = function () {
        return { 'Authorization': this.token };
    };
    HttpService.prototype.tryRefreshToken = function (observer, cache) {
        // console.log('token refreshing');
        var that = this;
        // that.spinner.spinnerInit();
        this.cognitoUtil.refresh(function (err) {
            if (err) {
                that.spinner.spinnerDone();
                observer.error(err);
                that.logout();
            }
            else {
                that.token = null;
                var json_1 = (cache.method === 'post' || cache.method === 'put');
                // console.log('bt:' + cache.businessType);
                // console.log('Cache: ' + JSON.stringify(cache));
                that.getHeader(json_1).subscribe(function (header) {
                    var options = { headers: header };
                    var http = (json_1) ? that._http[cache.method](cache.url, cache.data, options) :
                        that._http[cache.method](cache.url, options);
                    // console.log('http', http);
                    http.subscribe(function (data) {
                        that.spinner.spinnerDone();
                        observer.next(data);
                    }, function (error) {
                        that.spinner.spinnerDone();
                        observer.error(error);
                        that.logout();
                    });
                });
            }
        });
        /*this.cognitoUtil.getRefreshToken({
          callbackWithParam: (token) => {
    
          }, callback: () => {}
        });*/
    };
    HttpService.prototype.cacheRequest = function (method, url, data) {
        // const businessType = Number(localStorage.getItem('catId'));
        return { method: method, url: url, data: data };
    };
    HttpService.prototype.post = function (url, data, noAuth) {
        var _this = this;
        return new Observable(function (observer) {
            _this.getHeader(true, noAuth).subscribe(function (header) {
                // console.log('header++', header);
                var options = { headers: header };
                _this.spinner.spinnerInit();
                var cache = _this.cacheRequest('post', AppConstant.AWS_API_ENDPOINT + url, data);
                _this.handler(_this._http.post(AppConstant.AWS_API_ENDPOINT + url, data, options), observer, cache);
            }, function (err) {
                // console.log(err);
                observer.error();
            });
        });
    };
    HttpService.prototype.put = function (url, data) {
        var _this = this;
        return new Observable(function (observer) {
            _this.getHeader(true).subscribe(function (header) {
                // console.log('header++', header);
                var options = { headers: header };
                _this.spinner.spinnerInit();
                var cache = _this.cacheRequest('put', AppConstant.AWS_API_ENDPOINT + url, data);
                _this.handler(_this._http.put(AppConstant.AWS_API_ENDPOINT + url, data, options), observer, cache);
            }, function (err) {
                // console.log(err);
                observer.error();
            });
        });
    };
    HttpService.prototype.get = function (url, data) {
        var _this = this;
        return new Observable(function (observer) {
            _this.getHeader(false).subscribe(function (header) {
                // console.log('header', header);
                var options = { headers: header };
                var query = (data) ? '?data=' + encodeURI(JSON.stringify(data)) : '';
                if (url !== '/customer/all') {
                    if (url !== '/driver/all') {
                        _this.spinner.spinnerInit();
                    }
                }
                var cache = _this.cacheRequest('get', AppConstant.AWS_API_ENDPOINT + url + query);
                _this.handler(_this._http.get(AppConstant.AWS_API_ENDPOINT + url + query, options), observer, cache);
            }, function (err) {
                // console.log(url);
                // console.error('err++', err);
                observer.error(err);
            });
        });
    };
    HttpService.prototype.delete = function (url, data) {
        var _this = this;
        return new Observable(function (observer) {
            _this.getHeader(false).subscribe(function (header) {
                var options = { headers: header };
                var query = (data) ? '?data=' + encodeURI(JSON.stringify(data)) : '';
                // console.log(query);
                _this.spinner.spinnerInit();
                var cache = _this.cacheRequest('delete', AppConstant.AWS_API_ENDPOINT + url + query);
                _this.handler(_this._http.delete(AppConstant.AWS_API_ENDPOINT + url + query, options), observer, cache);
            }, function (err) {
                // console.error('err++', err);
                observer.error(err);
            });
        });
    };
    HttpService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpClient, StorageService, CognitoUtil,
            Router, AppUtil])
    ], HttpService);
    return HttpService;
}());
export { HttpService };



//////////////////
// WEBPACK FOOTER
// ./src/app/common/http.service.ts
// module id = ./src/app/common/http.service.ts
// module chunks = main